import { Inject, Injectable } from "@angular/core";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { environment } from "../../../environments/environment";

@Injectable()
export class SharedService {
    private defaultTransparenciaUrl = `${environment.defaultTransparenciaUrl}`;
    private defaultSaiUrl = `${environment.defaultSaiUrl}`;
        
    constructor() { }

    formatarCPFCNPJ(cpf_cnpj: string): string {
        const digits = cpf_cnpj.replace(/\D/g, '');
        if (digits.length === 11)
            return this.formatarCPF(cpf_cnpj);
        else
            return this.formatarCNPJ(cpf_cnpj);
    }

    formatarCPF(cpf: string): string {
        const digits = cpf.replace(/\D/g, '');

        return `${digits.substring(0, 3)}.${'***'}.${'***'}-${'**'}`;
    }

    formatarCNPJ(cnpj: string): string {

        const digits = cnpj.replace(/\D/g, '');

        return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    resolveTransparenciaUrl(siteOrgao: string): string {
        const des_url_sit = siteOrgao;

        if (des_url_sit.includes('.gov.br')) {
            const cleanUrl = des_url_sit.replace(/^www\./, '');
            return `https://transparencia.${cleanUrl}`;
        }

        return `${this.defaultTransparenciaUrl}/${des_url_sit}`;
    }

    resolvePathTransparencia(path: string, siteOrgao: string): string[] {
        const defaultUrl = this.resolveTransparenciaUrl(siteOrgao);

        const paths = path.split("|").map(p => p.trim()).filter(p => p);

        return paths.map(p => `${defaultUrl}/${p}`);
    }

    resolveSaiUrl(siteOrgao: string): string {
        let des_url_sit = siteOrgao;

        des_url_sit = des_url_sit.replace(/^www\./, '');

        if (des_url_sit.includes('.gov.br')) {
            return `https://${des_url_sit}`;
        }

        return `${this.defaultSaiUrl}/${des_url_sit}`;
    }

    resolvePathSai(path: string, siteOrgao: string): string[] {
        const defaultUrl = this.resolveSaiUrl(siteOrgao);

        const paths = path.split("|").map(p => p.trim()).filter(p => p);

        return paths.map(p => `${defaultUrl}/${p}`);
    }

    omitKey<T, K extends keyof T>(obj: T, key: K): Omit<T, K> {
        const { [key]: _, ...rest } = obj;
        return rest;
    }
}